import { StyleSheet, TouchableOpacity, View } from "react-native";
import { Text } from "react-native-paper";

import type { QuestionComponentProps } from "./types";

import { colors, fonts } from "@/lib/theme";

/**
 * Radio single-select control — flat-section v2 visual.
 *
 * Vertical stack of pill-cards. Each pill has a 18px ring on the left and
 * the option text on the right. Selected = ink fill with white text and a
 * white-bordered ring containing a 6px white dot. Unselected = white
 * surface, ink text, hairline border.
 */
export function RadioQuestion({ question, value, onChange, readOnly }: QuestionComponentProps) {
    return (
        <View style={styles.column}>
            {question.answerOptions.map((option) => {
                const on = value === option.value;
                return (
                    <TouchableOpacity
                        key={option.id}
                        activeOpacity={0.85}
                        disabled={readOnly}
                        onPress={() => onChange(option.value)}
                        style={[styles.row, on ? styles.rowOn : styles.rowOff]}
                    >
                        <View style={[styles.ring, on ? styles.ringOn : styles.ringOff]}>
                            {on ? <View style={styles.dot} /> : null}
                        </View>
                        <Text style={[styles.label, on ? styles.labelOn : styles.labelOff]}>
                            {option.text}
                        </Text>
                    </TouchableOpacity>
                );
            })}
        </View>
    );
}

const styles = StyleSheet.create({
    column: {
        flexDirection: "column",
        gap: 8
    },
    row: {
        flexDirection: "row",
        alignItems: "center",
        gap: 12,
        paddingVertical: 13,
        paddingHorizontal: 14,
        borderRadius: 14,
        borderWidth: 1.5
    },
    rowOn: {
        backgroundColor: colors.ink,
        borderColor: colors.ink
    },
    rowOff: {
        backgroundColor: colors.surface,
        borderColor: colors.border
    },
    ring: {
        width: 18,
        height: 18,
        borderRadius: 9,
        borderWidth: 2,
        alignItems: "center",
        justifyContent: "center"
    },
    ringOn: {
        borderColor: "#FFFFFF",
        backgroundColor: colors.ink
    },
    ringOff: {
        borderColor: colors.gray400,
        backgroundColor: "transparent"
    },
    dot: {
        width: 6,
        height: 6,
        borderRadius: 3,
        backgroundColor: "#FFFFFF"
    },
    label: {
        flex: 1,
        fontFamily: fonts.semiBold,
        fontSize: 14
    },
    labelOn: { color: "#FFFFFF" },
    labelOff: { color: colors.ink }
});
